import React, { useMemo } from "react";
import { getScaleBarMeasurement } from "./MapViewUtils";
import "./ScaleBar.css";

function ScaleBar({ center, zoom }) {
  const scale = useMemo(
    () => getScaleBarMeasurement(center?.[0] || 0, zoom || 0),
    [center, zoom]
  );

  return (
    <div className="scale-bar">
      <div className="scale-bar-line" style={{ width: `${scale.widthPx}px` }} />
      <div className="scale-bar-label">{scale.label}</div>
    </div>
  );
}

export default ScaleBar;
